/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { ProjectBranchSelector } from '~private-shared/components/project-branch-selector/ProjectBranchSelector';
import * as aica from '~sq-server-features/feature-aica';
import * as architecture from '~sq-server-features/feature-architecture';
import * as branches from '~sq-server-features/feature-branches';
import * as issuesSandbox from '~sq-server-features/feature-issue-sandbox';
import * as jira from '~sq-server-features/feature-jira';
import * as license from '~sq-server-features/feature-license';
import * as sca from '~sq-server-features/feature-sca';
import * as slack from '~sq-server-features/feature-slack';

enum AddonKeys {
  Aica = 'aica',
  Architecture = 'architecture',
  Branches = 'branches',
  IssueSandbox = 'issueSandbox',
  Jira = 'jira',
  License = 'license',
  Sca = 'sca',
  Slack = 'slack',
}

const allAddons = {
  [AddonKeys.Branches]: { ...branches, ProjectBranchSelector },
  [AddonKeys.Sca]: sca,
  [AddonKeys.License]: license,
  [AddonKeys.Architecture]: architecture,
  [AddonKeys.Aica]: aica,
  [AddonKeys.IssueSandbox]: issuesSandbox,
  [AddonKeys.Jira]: jira,
  [AddonKeys.Slack]: slack,
};

export type AddonsType = Partial<typeof allAddons>;
export const addons: AddonsType = allAddons;
